import type { ISO6391LanguageCode } from 'shared/types/locale';
import { getUiStoreState, useUiStore } from '../store';
import { isAnyFormEditing } from '../model';
import type { UiSyncActions } from '../types';

export function useCurrentLocale(): ISO6391LanguageCode {
  return useUiStore((state) => state.data.currentLocale);
}

export function useIsFormEditing(form: string): boolean {
  return useUiStore((state) => Boolean(state.data.isFormEditing[form]));
}

export function useIsVersionMismatched(): boolean {
  return useUiStore((state) => state.data.mismatchedVersion);
}

export function useUiActions(): UiSyncActions {
  return useUiStore.use.actions();
}

export function getCurrentLocale(): ISO6391LanguageCode {
  return getUiStoreState().data.currentLocale;
}

export function hasFormsInEditing(): boolean {
  return isAnyFormEditing(getUiStoreState().data);
}
